'use strict';

define(['codes'], function () {
  var codes = [['konamiCode', [38, 38, 40, 40, 37, 39, 37, 39, 66, 65]], // Up up down down left right left right b a
  ['gtaVC', [37, 40, 39, 38, 37, 40, 39, 38, 66, 65]], // Left down right up left down right up b a
  ['spinRight', [39, 40, 37, 38, 39, 40, 37, 38, 66, 65]], // Right down left up right down left up b a
  ['chaChaSlide', [37, 39, 37, 39, 37, 39, 66, 65]] // Left right left right left right b a
  ],
      userInput = [],
      codeCall,
      highest = Number.NEGATIVE_INFINITY,
      lowest = Number.POSITIVE_INFINITY;

  var code = {
    codeCall: {
      numberWang: function numberWang() {}
    },

    /**
     * Initiate the code script
     * @param parentScope
     */
    levelUp: function levelUp(parentScope) {
      parentScope.maxCodeLength();
      window.onkeyup = function (e) {
        parentScope.listen(e.keyCode);
      };
    },

    /**
     * Listen for codes
     * @param keyCode
     */
    listen: function listen(keyCode) {
      userInput.push(keyCode);
      var length = userInput.length;
      if (length < lowest) {
        return false;
      }
      if (length > highest) {
        userInput.splice(0, 1);
      }
      this.map(userInput);
    },

    /**
     * Set max and min length of codes
     */
    maxCodeLength: function maxCodeLength() {
      var superCode;
      for (var i = codes.length - 1; i > -1; i--) {
        superCode = codes[i][1].length;
        if (superCode < lowest) lowest = superCode;
        if (superCode > highest) highest = superCode;
      }
    },

    /**
     * Compare input to codes
     * @param userInput
     * @returns {*}
     */
    map: function map(userInput) {
      for (var i = 0; codes.length > i; i++) {
        var code = codes[i][0];
        if (this.contains(codes[i][1], userInput)) {
          try {
            return this.codeCall[code]();
          } catch (e) {
            return this.codeCall.numberWang();
          }
        }
      }
    },

    /**
     * Check if a code is within or the same as the user input
     * @param code
     * @param userInput
     * @returns {boolean}
     */
    contains: function contains(code, userInput) {
      var newUserInput = userInput.slice(0);
      var remaining = parseInt(newUserInput.length) - parseInt(code.length);
      newUserInput.splice(0, remaining);
      return String(newUserInput) === String(code);
    }
  };

  return code;
});
//# sourceMappingURL=codes.js.map
